export * from './reset-password-form-page.component';
